var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kst-icon"},[(_vm.theIcon)?[_c('span',{staticClass:"icon",class:_vm.theClass},[_c('i',{class:_vm.theIcon})])]:[_c('span',{staticClass:"has-text-white has-background-info px-1 k-radius ks-cursor-default"},[_vm._v(" "+_vm._s(_vm.theLabel)+" ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }